<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-lg-2 col-xl-2 navbar-collapse sidebar">
        <div class="sidebar-header">
          <a class="vik-brand" href="#">
            <img src="@/assets/logo.svg" alt />
          </a>
          <div id="dismissSidebar">
            <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              class="SideNav__closeIcon__56eIa" stroke="currentColor" tabindex="0">
              <path d="M1 1L23 23M1 23L23 1" />
            </svg>
          </div>
        </div>
        <div class="head-page">
          <div class="page-title">
            <div class="title">
              <h1>Tasks</h1>
            </div>
          </div>

          <div class="search-group">
            <input type="text" class="form-control" placeholder="filter" v-model="query" @input="loadTasks(true)" />
            <div class="input-icon">
              <i class="vik vik-search"></i>
            </div>
          </div>
          <router-link tag="button" class="btn btn-primary btn-lg" :to="{ name: 'NewTask' }">
            <i class="vik vik-plus"></i>New task
          </router-link>
        </div>
        <div class="card-cont">
          <VuePerfectScrollbar v-if="filteredTasks.length > 0" class="scroll-area card-list"
            :settings="{ wheelPropagation: false }" @ps-y-reach-end="scrollEnd">
            <router-link tag="div" v-for="item in filteredTasks" :key="item.status + item.id"
              :to="{ name: 'SingleSchedTask', params: { id: item.id } }" v-bind:class="{
                active: item.id == $route.params.id,
                'status-process': item.status === 'process',
                'status-pause': item.status === 'paused',
                'status-warning': item.status === 'aborted',
                'status-result': item.status === 'done',
                'status-stop': item.status === 'created',
              }" class="card status-bar">
              <div class="card-body">
                <h5 class="card-title">{{ item.task_name }}</h5>
                <span class="card-info">status: {{ item.status }}</span>
              </div>
            </router-link>
          </VuePerfectScrollbar>

          <!--
            <div
              class="card status-bar status-process"
              data-toggle="tooltip"
              data-placement="top"
              title="In the process"
            >
              <div class="card-body">
                <h5 class="card-title">asdasd</h5>
                <span class="card-info">targets count: xxx</span>
              </div>
            </div>
            <div
              class="card active status-bar status-pause"
              data-toggle="tooltip"
              data-placement="top"
              title="Pause"
            >
              <div class="card-body">
                <div class="status-bar"></div>
                <h5 class="card-title">* basic info</h5>
                <span class="card-info">targets count: -1</span>
              </div>
            </div>
            <div class="card status-bar status-result" title="Result">

            </div>

            <div
              class="card status-bar status-stop"
              data-toggle="tooltip"
              data-placement="top"
              title="Stopped"
            >
            </div>
            <div
              class="card status-bar status-warning"
              data-toggle="tooltip"
              data-placement="top"
              title="Warning"
            >
              <div class="card-body">
                <h5 class="card-title">* basic info</h5>
                <span class="card-info">targets count: -1</span>
              </div>
            </div>
            -->

          <div v-else class="card-list">no tasks</div>
        </div>
      </div>
      <div class="col">
        <div class="content" v-if="$route.params.id">
          <router-view />
        </div>
        <div v-else class="content">
          <div class="atom-card-cont" style="width: 50%">
            <h2>Schedule</h2>
            <div class="tip">
              <p>Системные задания используются для автоматизации повторяющихся действий. Тут можно создать задание, которое будет выполняться в определенное время.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from "@/bus.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { getTasks } from "@/api.js";

export default {
  components: { VuePerfectScrollbar },
  data() {
    return {
      tasks: [],
      query: "",
      noMore: false,
      loading: false,
      showWebTasks: false,
    };
  },
  created() {
    let that = this;
    bus.$on("refresh-tasks", function (reset) {
      that.loadTasks(reset);
    });
    bus.$on("new-task-status", function (data) {
      for (var i in that.tasks) {
        if (that.tasks[i].id == data.id) {
          that.tasks[i].status = data.status;
        }
      }
    });
  },
  mounted() {
    let that = this;
    that.loadTasks(true).then(() => {
      // go to atom view
      if (this.tasks.length > 0) {
        // redirect
        if (!("id" in this.$route.params))
          this.$router.replace({
            name: "SingleTask",
            params: {
              id: this.tasks[0].id,
            },
          });
      }
    });
  },
  computed: {
    disabled() {
      return this.loading || this.noMore;
    },
    filteredTasks() {
      let that = this;
      if (this.query !== "") {
        return this.tasks.filter((task) => {
          return task.task_name
            .toLowerCase()
            .includes(that.query.toLowerCase());
        });
      } else {
        return this.tasks;
      }

      /*
      return _.uniqBy(this.tasks, "id").filter((task) => {
        return task.task_name.toLowerCase().includes(this.filter.toLowerCase());
      });
      */
    },
  },
  methods: {
    scrollEnd: function () {
      if (this.tasks.length > 5) this.loadTasks(false);
    },
    onShowWebTasksChange(v) {
      this.showWebTasks = !this.showWebTasks;
      this.loadTasks(true);
    },

    async loadTasks(reset) {
      this.loading = true;
      this.noMore = false;
      let that = this;
      if (reset) this.tasks = [];

      getTasks(this.query, this.tasks.length).then((data) => {
        for (let t of data.Records) {
          that.tasks.push(t);
        }
        if (data.Records.length != 50) {
          this.noMore = true;
        }
        this.loading = false;
      });

      /*
      return new Promise((resolve, reject) => {
        fetch(
          `/api/tasks/?offset=${}&q=${this.filter}&web=${this.showWebTasks}`
        )
          .then((response) => {
            this.loading = false;
            if (response.status !== 200) {
              console.log(
                "Looks like there was a problem. Status Code: " +
                  response.status
              );
              reject();
            }
            response.json().then((data) => {
              data.tasks.forEach((task) => {
                this.tasks.push(task);
              });

              if (data.tasks.length != 50) {
                this.noMore = true;
              }
              resolve();
            });
          })
          .catch(function (err) {
            console.log("Fetch Error :-S", err);
            reject();
          });
      });
      */
    },
  },
};
</script>
<style scoped>
.tip {
    padding: 8px 16px;
    background-color: #ffffff;
    border-radius: 4px;
    border-left: 5px solid #BDCDD0;
    margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/Sched.vue